
import React, { Component } from 'react'
import $ from 'jquery';
import axios from 'axios';
import { ApiUrl } from '../../services/ApiRest';
import swal from 'sweetalert';

//Rutas de ingreso de matriz
const urlListPeriodos = ApiUrl + "listperiodostodos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const inscribirUrlListarCarrera = ApiUrl + "listarcarreras" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const devuelNumNivelesCarrera = ApiUrl + "numnivelescarr" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const inscribirUrlColegituraPeriodC = ApiUrl + "ingresarcolegituraperiodcarr" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const carrerasUrl = inscribirUrlListarCarrera;

export default class ColegiaturasCarrPeriodo extends Component {

    constructor(props) {
        super(props)
        this.inputRefs = {};
        this.state = {
            nivel1: '',
            nivel2: '',
            nivel3: '',
            nivel4: '',
            nivel5: '',
            nivel6: '',
            carrera_seleccionada: '',
            carrera: [],
            estado: '',
            //nuevas variables
            numnivelescarr: '',
            listaperiodos: [],
            listaniveles: [],
        }
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ carrera_seleccionada: this.state.idCarrera });
        this.setState({ estado: "" });
    }

    handleInputChange = (e, codnivel, campo) => {
        const updatedNiveles = this.state.listaniveles.map(nivel => {
            if (nivel.codnivel === codnivel) {
                return { ...nivel, [campo]: e.target.value };
            }
            return nivel;
        });
        this.setState({ listaniveles: updatedNiveles });
    };

    handleChangeDevolverIdCarrera = async (e) => {
        const nuevaCarrera = e.target.value;

        // Actualiza primero el estado
        await this.setState({ [e.target.name]: nuevaCarrera });
        this.setState({ carrera_seleccionada: nuevaCarrera });

        // 🔴 Limpiar inputs actuales antes de consultar nuevos datos
        this.state.listaniveles.forEach((nivel) => {
            const cod = nivel.codnivel;
            if (this.inputRefs[`${cod}_valormensual`]) this.inputRefs[`${cod}_valormensual`].value = "";
            if (this.inputRefs[`${cod}_valortotal`]) this.inputRefs[`${cod}_valortotal`].value = "";
            if (this.inputRefs[`${cod}_numcuotas`]) this.inputRefs[`${cod}_numcuotas`].value = "";
        });

        // 🔄 Consulta nuevos datos para la carrera seleccionada
        axios
            .post(devuelNumNivelesCarrera, {
                idCarreraf: nuevaCarrera,
                periodoIdf: this.state.idPeriodoSelect,
            })
            .then(response => {
                const listaniveles1 = response.data.data;
                this.setState({ listaniveles: listaniveles1 }, () => {
                    // Después de actualizar el estado, actualiza los inputs manualmente
                    listaniveles1.forEach((nivel) => {
                        const cod = nivel.codnivel;
                        if (this.inputRefs[`${cod}_valormensual`])
                            this.inputRefs[`${cod}_valormensual`].value = nivel.valor_mensualf || "";
                        if (this.inputRefs[`${cod}_valortotal`])
                            this.inputRefs[`${cod}_valortotal`].value = nivel.valor_totalf || "";
                        if (this.inputRefs[`${cod}_numcuotas`])
                            this.inputRefs[`${cod}_numcuotas`].value = nivel.valor_numcuotasf || "";
                    });
                });
            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    };

    componentDidMount() {
        axios.get(carrerasUrl)
            .then(res => {
                const carrera = res.data;
                this.setState({ carrera });
            })

        axios
            .get(urlListPeriodos)
            .then(response => {
                const listaperiodos = response.data.data;
                const cant = listaperiodos.length;
                if (cant != 0) {
                    this.setState({ listaperiodos });
                }
            })
    }

    registrarColegiaturasPeriodo = async () => {
        let materiasselect = [];

        this.state.listaniveles.forEach((nivel) => {
            const idnivel = nivel.codnivel;
            const valorM = this.inputRefs[`${idnivel}_valormensual`]?.value || "";
            const valorT = this.inputRefs[`${idnivel}_valortotal`]?.value || "";
            const valorNumCuota = this.inputRefs[`${idnivel}_numcuotas`]?.value || "";

            materiasselect.push({
                idnivelf: idnivel,
                valormf: valorM,
                valortf: valorT,
                valornumcuotaf: valorNumCuota,
            });
        });

        try {
            const response = await axios.post(inscribirUrlColegituraPeriodC, {
                periodoactualef: this.state.idPeriodoSelect,
                listColegiaturasPf: materiasselect,
                idCarreraf: this.state.idCarrera,
            });

            if (response.data.success === true) {
                swal({
                    text: "Datos registrados",
                    icon: "success",
                    button: "Aceptar",
                });

                // Recarga lista de niveles
                const resp = await axios.post(devuelNumNivelesCarrera, {
                    idCarreraf: this.state.idCarrera,
                    periodoIdf: this.state.idPeriodoSelect,
                });

                this.setState({ listaniveles: resp.data.data });
            } else {
                swal({
                    text: "Datos no registrados",
                    icon: "error",
                    button: "Aceptar",
                });
            }
        } catch (error) {
            this.setState({ estado: "Error No se pudo conectar con el servidor" });
            swal({
                text: "Datos no registrados",
                icon: "error",
                button: "Aceptar",
            });
        }
    };

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <div className="card p-3 mb-2 bg-white rounded-4 shadow-sm border-0">
                    <div className="back-istmas d-flex align-items-center">
                        <i className="fa fa-dollar-sign bounce-custom fs-5 me-2"></i>
                        <b className="mb-0 fw-semibold">Costos de Colegiatura</b>
                    </div>

                    <div className="p-3 rounded-3">
                        <div className="row g-3">
                            <div className="col-12 col-md-6">
                                <label className="form-label text-azul small">
                                    <i className="fa fa-calendar me-1"></i> Período:
                                </label>
                                <select
                                    className="form-select form-select-sm"
                                    name="idPeriodoSelect"
                                    value={this.state.idPeriodoSelect}
                                    onChange={this.handleChange}
                                >
                                    <option value="undefined">Seleccione el período</option>
                                    {this.state.listaperiodos.map(periodo => (
                                        <option
                                            key={periodo.id_periodo_academico}
                                            value={periodo.id_periodo_academico}
                                        >
                                            {periodo.descripcion_periodo_academico}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-12 col-md-6">
                                <label className="form-label text-azul small">Carrera:</label>
                                <select
                                    className="form-select form-select-sm"
                                    name="idCarrera"
                                    value={this.state.idCarrera}
                                    onChange={this.handleChangeDevolverIdCarrera}
                                >
                                    <option value="undefined">Seleccione una carrera</option>
                                    {this.state.carrera.map(person => (
                                        <option key={person.id_carrera} value={person.id_carrera}>
                                            {person.descripcion_carrera}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="table-responsive mt-4">
                            <table className="table table-sm table-hover align-middle">
                                <thead className="small text-center table-light">
                                    <tr>
                                        <th className="text-start text-azul">Nivel</th>
                                        <th className="text-start text-azul">Valor Mensual</th>
                                        <th className="text-start text-azul">Valor Total</th>
                                        <th className="text-start text-azul"># Cuotas</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.listaniveles.map((nivel) => (
                                        <tr key={nivel.codnivel}>
                                            <td className="text-azul small">{nivel.codnivel}</td>
                                            <td>
                                                <input
                                                    type="text"
                                                    ref={el => (this.inputRefs[`${nivel.codnivel}_valormensual`] = el)}
                                                    className="form-control form-control-sm"
                                                    defaultValue={nivel.valor_mensualf}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    ref={el => (this.inputRefs[`${nivel.codnivel}_valortotal`] = el)}
                                                    className="form-control form-control-sm"
                                                    defaultValue={nivel.valor_totalf}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    ref={el => (this.inputRefs[`${nivel.codnivel}_numcuotas`] = el)}
                                                    className="form-control form-control-sm"
                                                    defaultValue={nivel.valor_numcuotasf}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="d-flex justify-content-center mt-4">
                            <button
                                type="button"
                                className="btn btn-sm btn-primary fw-semibold px-3 py-1 shadow-sm"
                                style={{ borderRadius: "8px", fontSize: "0.85rem" }}
                                onClick={() => this.registrarColegiaturasPeriodo()}
                            >
                                <i className="fas fa-check me-1"></i>Registrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

